import {
  FETCH_TWILIO_CONVERSATIONS_SUCCESS,
  PUSH_TWILIO_CONVERSATION_SUCCESS,
} from '../actions';

const INIT_STATE = {
  twilioConversations: [],
};

const twilioConversationsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_TWILIO_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        twilioConversations: action.payload,
      };
    case PUSH_TWILIO_CONVERSATION_SUCCESS:
      return {
        ...state,
        twilioConversations: [...state.twilioConversations, action.payload],
      };
    default:
      return { ...state };
  }
};

export default twilioConversationsReducer;
